export function isEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }

  return true;
}
export const GetUserInfo = () => {
  let Info = sessionStorage.getItem("userData");
  if (Info && Info !== "undefined" && !isEmpty(Info)) {
    return JSON.parse(Info);
  }
};
const getFullName = () => {
  let Info = sessionStorage.getItem("userData");
  let data;
  if (Info && Info !== "undefined" && !isEmpty(Info)) {
    data = JSON.parse(Info);
    if (data && data.userDetails) {
      return data?.userDetails[0]?.Full_Name;
    }
  }
};
const getUserName = () => {
  let Info = sessionStorage.getItem("userData");
  let data;
  if (Info && Info !== "undefined" && !isEmpty(Info)) {
    data = JSON.parse(Info);
    if (data && data.userDetails) {
      return data.userDetails[0].UserName;
    }
  }
};
const getUserMobile = () => {
  let Info = sessionStorage.getItem("userData");
  let data;
  if (Info && Info !== "undefined" && !isEmpty(Info)) {
    data = JSON.parse(Info);
    if (data && data.userDetails) {
      return data.userDetails[0].Mobile;
    }
  }
};
const getComponeycodeID = () => {
  let Info = sessionStorage.getItem("CompanyCode");
  let data;
  if (Info && Info !== "undefined" && !isEmpty(Info)) {
    data = JSON.parse(Info);
    return data.id;
  }
};
const getComponeycode = () => {
  let Info = sessionStorage.getItem("userData");
  let data;

  if (Info && Info !== "undefined" && !isEmpty(Info)) {
    data = JSON.parse(Info);
    if (data?.userDetails) {
      return data?.userDetails[0]?.CompanyCode?.CompanyCode;
    }
  }
};

const getUserID = () => {
  let Info = sessionStorage.getItem("userData");
  let data;
  if (Info && Info !== "undefined" && !isEmpty(Info)) {
    data = JSON.parse(Info);
    if (data && data.userDetails) {
      return data.userDetails[0]._id;
    }
  }
};

const getCompanyCode = async () => {
  return JSON.parse(sessionStorage.getItem("CompanyCode"));
};

const getBranchCode = async () => {
  return JSON.parse(sessionStorage.getItem("BranchCode"));
};
const getSelectedFinancialYear = async () => {
  return JSON.parse(sessionStorage.getItem("SelectedFinancialYear"));
};

const getLicenseeCode = async () => {
  return sessionStorage.getItem("LicenseeCode");
};
const getUserRole = async () => {
  const userData = JSON.parse(sessionStorage.getItem("userData") ?? "null");
  const userRole = userData?.userDetails?.[0]?.Role;
  return userRole;
};

export const getGstAndPincode = () => {
  let Company = sessionStorage.getItem("CompanyCode") && JSON.parse(sessionStorage.getItem("CompanyCode"));

  return {
    GST_Number: Company?.GST_Number,
    Pincode: Company?.Pincode,
    State: Company?.State,
  };
};

export {
  getUserName,
  getComponeycodeID,
  getUserMobile,
  getComponeycode,
  getUserID,
  getFullName,
  getCompanyCode,
  getBranchCode,
  getSelectedFinancialYear,
  getLicenseeCode,
  getUserRole,
};
